// Authentication
const lobbyContainer = () => import(/* webpackChunkName: "lobbyContainer" */ '@/components/lobby-container')
const loginPage = () => import(/* webpackChunkName: "loginPage" */ '@/pages/login')
const registerPage = () => import(/* webpackChunkName: "registerPage" */ '@/pages/register.vue')
const confirmationPage = () => import(/* webpackChunkName: "confirmationPage" */ '@/pages/confirmation.vue')
const resetPasswordPage = () => import(/* webpackChunkName: "resetPasswordPage" */ '@/pages/reset-password.vue')

// Client
const authenticatedPage = () => import(/* webpackChunkName: "authenticatedPage" */ '@/pages/authenticated/index')
const dashboardPage = () => import(/* webpackChunkName: "dashboardPage" */ '@/pages/dashboard')
const holdingsDashboard = () => import(/* webpackChunkName: "holdingsDashboard" */ '@/pages/dashboard/holdings/page-holdings-dashboard')
const dashboardContracts = () => import(/* webpackChunkName: "dashboardContracts" */ '@/pages/dashboard/dashboard-contracts')
const loansDashboard = () => import(/* webpackChunkName: "loansDashboard" */ '@/pages/dashboard/loans/page-loans-dashboard')
const dashboardLoansContracts = () => import(/* webpackChunkName: "dashboardLoansContracts" */ '@/pages/dashboard/dashboard-loans-contracts')

const contractPage = () => import(/* webpackChunkName: "contractPage" */ '@/pages/contract')
const contractOverview = () => import(/* webpackChunkName: "contractOverview" */ '@/pages/contract/contract-overview')
const contractProject = () => import(/* webpackChunkName: "contractProject" */ '@/pages/contract/contract-project')
const contractAllocation = () => import(/* webpackChunkName: "contractAllocation" */ '@/pages/contract/contract-allocation')
const contractInvestments = () => import(/* webpackChunkName: "contractInvestments" */ '@/pages/contract/contract-investments')
const contractSettings = () => import(/* webpackChunkName: "contractSettings" */ '@/pages/contract/contract-settings')
const contractDetails = () => import(/* webpackChunkName: "contractDetails" */ '@/pages/contract/contract-details')
const contractDocuments = () => import(/* webpackChunkName: "contractDocuments" */ '@/pages/contract/contract-documents')
const contractInformations = () => import(/* webpackChunkName: "contractInformations" */ '@/pages/contract/contract-informations')
const contractInfoNeeded = () => import(/* webpackChunkName: "contractInfoNeeded" */ '@/pages/contract/contract-info-needed')
const realestatePage = () => import(/* webpackChunkName: "realestatePage" */ '@/pages/real-estate')
const realEstateFormAddNew = () => import(/* webpackChunkName: "realEstateAddForm" */ '@/pages/accounts/real-estate/form-add-new.vue')
const realEstateEvaluate = () => import(/* webpackChunkName: "realEstateEvaluate" */ '@/pages/accounts/real-estate/evaluate.vue')
const realEstateSettings = () => import(/* webpackChunkName: "realEstateSettings" */ '@/pages/contract/realestate/realestate-settings.vue')

const analysePage = () => import(/* webpackChunkName: "analysePage" */ '@/pages/analyse')
const analyseAllocation = () => import(/* webpackChunkName: "analyseAllocation" */ '@/pages/analyse/analyse-allocation')
const analysePerf = () => import(/* webpackChunkName: "analysePerf" */ '@/pages/analyse/analyse-perf')
const analyseRisk = () => import(/* webpackChunkName: "analyseRisk" */ '@/pages/analyse/analyse-risk')
const analyseFees = () => import(/* webpackChunkName: "analyseFees" */ '@/pages/analyse/analyse-fees')
const analyseAdvices = () => import(/* webpackChunkName: "analyseAdvices" */ '@/pages/analyse/analyse-advices')

const arbitrationPage = () => import(/* webpackChunkName: "arbitrationPage" */ '@/pages/arbitration')
const arbitrationStart = () => import(/* webpackChunkName: "arbitrationStart" */ '@/pages/arbitration/arbitration-start')
const arbitrationMarket = () => import(/* webpackChunkName: "arbitrationMarket" */ '@/pages/arbitration/arbitration-market')
const arbitrationOptimize = () => import(/* webpackChunkName: "arbitrationOptimize" */ '@/pages/arbitration/arbitration-optimize')

const userPage = () => import(/* webpackChunkName: "userPage" */ '@/pages/user.vue')
const userInfos = () => import(/* webpackChunkName: "userInfos" */ '@/pages/user/user-infos')
const userProfile = () => import(/* webpackChunkName: "userProfile" */ '@/pages/user/user-profile')
const userHoldings = () => import(/* webpackChunkName: "userHoldings" */ '@/pages/user/user-holdings')
const userAdvisor = () => import(/* webpackChunkName: "userAdvisor" */ '@/pages/user/user-advisor')
const userNotifications = () => import(/* webpackChunkName: "userNotifications" */ '@/pages/user/user-notifications')
const userPayment = () => import(/* webpackChunkName: "userPayment" */ '@/pages/user/user-payment')
const deleteProfile = () => import(/* webpackChunkName: "deleteProfile" */ '@/pages/delete-profile')

const subscriptionPage = () => import(/* webpackChunkName: "subscriptionPage" */ '@/pages/subscription.vue')
const paymentPage = () => import(/* webpackChunkName: "paymentPage" */ '@/pages/payment.vue')

const accountsAdd = () => import(/* webpackChunkName: "accountsAdd" */ '@/pages/accounts/add.vue')
const accountsAddIndex = () => import(/* webpackChunkName: "accountsAddIndex" */ '@/pages/accounts/add/index.vue')
const accountsAddForm = () => import(/* webpackChunkName: "accountsAddForm" */ '@/pages/accounts/add/form-bank-add.vue')
const accountWebauthRedirect = () => import(/* webpackChunkName: "accountWebauthRedirect" */ '@/pages/accounts/add/AccountWebauthRedirect.vue')
const accountsNewList = () => import(/* webpackChunkName: "accountsNewList" */ '@/pages/accounts/add/accounts-list.vue')
const accountsUpdateCredentials = () => import(/* webpackChunkName: "accountsUpdateCredentials" */ '@/pages/accounts/update/credentials.vue')
const accountsLoad = () => import(/* webpackChunkName: "accountsLoad" */ '@/pages/accounts/load.vue')
const accountsBITerms = () => import(/* webpackChunkName: "accountsLoad" */ '@/pages/bi-terms.vue')

const profileFill = () => import(/* webpackChunkName: "profileFill" */ '@/pages/accounts/profile')
const profileFillRisk = () => import(/* webpackChunkName: "profileFillRisk" */ '@/pages/accounts/profile/questions')
const profileFillInfos = () => import(/* webpackChunkName: "profileFillInfos" */ '@/pages/accounts/profile/infos')
const profileResult = () => import(/* webpackChunkName: "profileResult" */ '@/pages/accounts/profile/result')

const accountsRisk = () => import(/* webpackChunkName: "accountsRisk" */ '@/pages/accounts/risk')

// Club
const clubLayout = () => import(/* webpackChunkName: "clubLayout" */ '@/pages/club/ClubLayout')
const ClubLanding = () => import(/* webpackChunkName: "ClubLanding" */ '@/pages/club/ClubLanding')
const ClubVerifyInfo = () => import(/* webpackChunkName: "ClubVerifyInfo" */ '@/pages/club/ClubVerifyInfo')
const clubPriceSelection = () => import(/* webpackChunkName: "clubPriceSelection" */ '@/pages/club/ClubPriceSelection')
const clubSubscription = () => import(/* webpackChunkName: "clubSubscription" */ '@/pages/club/ClubSubscription')
const clubDashboard = () => import(/* webpackChunkName: "clubDashboard" */ '@/pages/club/ClubDashboard')
const ClubPortfolios = () => import(/* webpackChunkName: "ClubPortfolios" */ '@/pages/club/ClubPortfolios')
const ClubSettings = () => import(/* webpackChunkName: "ClubSettings" */ '@/pages/club/ClubSettings')
const ClubUnsubscribe = () => import(/* webpackChunkName: "ClubUnsubscribe" */ '@/pages/club/ClubUnsubscribe')
const ClubExitSurvey = () => import(/* webpackChunkName: "ClubExitSurvey" */ '@/pages/club/ClubExitSurvey')
const ClubPortfoliosSelection = () => import(/* webpackChunkName: "ClubPortfoliosSelection" */ '@/pages/club/ClubPortfoliosSelection')
const ClubPaymentInfos = () => import(/* webpackChunkName: "ClubPaymentInfos" */ '@/pages/club/ClubPaymentInfos')
const ClubWaitingAdvisor = () => import(/* webpackChunkName: "ClubWaitingAdvisor" */ '@/pages/club/ClubWaitingAdvisor')

// Advisor
const advisoryPage = () => import(/* webpackChunkName: "advisoryPage" */ '@/pages/advisory/index')

const advisoryCustomers = () => import(/* webpackChunkName: "advisoryCustomers" */ '@/pages/advisory/advisory-customers')
const advisoryCustomersList = () => import(/* webpackChunkName: "advisoryCustomersList" */ '@/pages/advisory/customers-list')
const advisoryCustomersAdd = () => import(/* webpackChunkName: "advisoryCustomersAdd" */ '@/pages/advisory/customers-add')
const advisoryCustomerInfos = () => import(/* webpackChunkName: "advisoryCustomerInfos" */ '@/pages/advisory/customer-infos')
const customerOverview = () => import(/* webpackChunkName: "customerOverview" */ '@/pages/advisory/customer/overview')

const customerInteractions = () => import(/* webpackChunkName: "customerInteractions" */ '@/pages/advisory/customer/customer-interactions')

const customerMissions = () => import(/* webpackChunkName: "customerMissions" */ '@/pages/advisory/customer/customer-missions')
const advisoryMissionsLayout = () => import(/* webpackChunkName: "advisoryMissionsLayout" */ '@/pages/advisory/missions/missions-layout')
const advisoryMissionsFinancials = () => import(/* webpackChunkName: "advisoryMissionsFinancials" */ '@/pages/advisory/missions/missions-financials')
const advisoryMissionsWizard = () => import(/* webpackChunkName: "advisoryMissionsWizard" */ '@/pages/advisory/missions/missions-wizard')
const advisoryMissionsDetails = () => import(/* webpackChunkName: "advisoryMissionsDetails" */ '@/pages/advisory/missions/missions-details')

const customerClub = () => import(/* webpackChunkName: "customerMissions" */ '@/pages/advisory/customer/club/ClubIndex')

const fundPage = () => import(/* webpackChunkName: "fundPage" */ '@/pages/fund')

const loading = () => import(/* webpackChunkName: "loading" */ '@/pages/loading')

// Errors
const error500 = () => import(/* webpackChunkName: "error500" */ '@/pages/errors/500')
const error404 = () => import(/* webpackChunkName: "error404" */ '@/pages/errors/404')

const pages = {
  loginPage,
  authenticatedPage,
  lobbyContainer,
  dashboardPage,
  holdingsDashboard,
  dashboardContracts,
  loansDashboard,
  dashboardLoansContracts,
  contractPage,
  contractOverview,
  contractProject,
  contractAllocation,
  contractInvestments,
  contractSettings,
  contractDetails,
  contractDocuments,
  contractInformations,
  contractInfoNeeded,
  realestatePage,
  deleteProfile,
  analysePage,
  analyseAllocation,
  analysePerf,
  analyseRisk,
  analyseFees,
  analyseAdvices,
  arbitrationPage,
  arbitrationStart,
  arbitrationMarket,
  arbitrationOptimize,
  userPage,
  userInfos,
  userProfile,
  userHoldings,
  userAdvisor,
  userNotifications,
  userPayment,
  registerPage,
  confirmationPage,
  resetPasswordPage,
  subscriptionPage,
  paymentPage,
  accountsAdd,
  accountsAddIndex,
  accountsAddForm,
  accountWebauthRedirect,
  accountsNewList,
  accountsUpdateCredentials,
  accountsLoad,
  accountsBITerms,
  realEstateFormAddNew,
  realEstateEvaluate,
  realEstateSettings,
  profileFill,
  profileFillRisk,
  profileFillInfos,
  profileResult,
  accountsRisk,
  clubLayout,
  ClubLanding,
  clubSubscription,
  clubDashboard,
  ClubPortfolios,
  ClubSettings,
  ClubUnsubscribe,
  ClubVerifyInfo,
  clubPriceSelection,
  ClubPortfoliosSelection,
  ClubPaymentInfos,
  ClubWaitingAdvisor,
  ClubExitSurvey,
  advisoryPage,
  advisoryCustomers,
  advisoryCustomersList,
  advisoryCustomersAdd,
  advisoryCustomerInfos,
  customerOverview,
  customerInteractions,
  customerMissions,
  advisoryMissionsLayout,
  advisoryMissionsFinancials,
  advisoryMissionsWizard,
  advisoryMissionsDetails,
  customerClub,
  fundPage,
  error500,
  error404,
  loading
}

export default pages
